<ng-container #entry></ng-container>
